<template>
  <base-section
    id="business-centres"
    space="5"
    class="mb-10"
    style="padding-bottom:200px"
  >
    <base-section-heading
      color="grey lighten-2"
      title="Наши здания"
      id="buildings"
    />
    <v-dialog
      v-model="dialog.contactForm"
      max-width="800px"
    >
      <base-contact-form
        title="наш специалист свяжется с вами"
        subtitle="Заполните форму"
        @close="dialog.contactForm = false"
      />
    </v-dialog>
    <v-container>
      <div class="align-content-center">
        <v-slide-group
          v-model="carousel"
          class="ma-3 pa-2"
          center-active
        >
          <v-slide-item
            v-for="(items, index) in business"
            :key="items.id_building + index"
            v-slot:default="{ toggle }"
          >
            <v-hover
              v-slot:default="{ hover }"
              open-delay="1"
            >
              <v-card
                class="mb-10 ma-2"
                max-width="355"
                :elevation="hover ? 10 : 3"
              >
                <v-img
                  :src="require('@/assets/' + items.image)"
                  height="200px"
                  @click="toggle"
                />
                <v-card-title style="font-size: 0.8rem">
                  {{ items.description[0].text }}
                </v-card-title>
                <v-card-subtitle>
                  {{ items.description[1].text }}
                </v-card-subtitle>
                <v-card-actions>
                  <v-btn
                    color="primary"
                    depressed
                    small
                    @click="open(items.id_building)"
                  >
                    {{ items.expand ? 'Свернуть':'Посмотреть помещения' }}
                  </v-btn>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    text
                    fab
                    @click="dialog.contactForm = true"
                  >
                    <v-icon>call</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-slide-item>
        </v-slide-group>
      </div>
    </v-container>
    <template v-for="(items, index) in business">
      <v-expand-transition
        :key="index"
      >
        <v-container>
          <v-row
            v-show="items.expand"
            justify="space-between"
          >
            <v-col
              cols="12"
              md="12"
            >
              <div v-if="selectedbuilding.description">
                <h2>{{ selectedbuilding.name_building }}</h2>
                <div>Адрес: {{ selectedbuilding.description[0] ? selectedbuilding.description[0].text:'' }}</div>
              </div>
              <div v-if="selectedbuilding.id_building === 3" id="kmg_class">
                <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1975.9 407.5" style="enable-background:new 0 0 1975.9 407.5;" xml:space="preserve">
                  <g id="bulding_kmg" opacity="0" class="blockA">
                    <polygon class="kmg_cover" id="bulding_kmg" opacity="0" points="990.9,155.1 991.1,222.1 979.6,222.8 968.6,224.8 959.2,227.8 950.8,231.6 946.4,234 942.4,236.4
                      942.4,334.8 939.4,340.7 888,340.7 887,341.9 870.3,341.9 869.1,343.2 768,345.8 768,346.8 567.8,356.4 558.8,348.4 559.4,331.9
                      555.3,332.1 555.3,234.9 657.3,237.3 657.3,206.3 731.1,206.2 731.5,98.4 752.8,98.4 752.6,101.3 834.8,101.9 834.8,90.7 830,85.6
                      830,83.3 831.5,83.3 831.5,82.1 832.5,82.1 832.5,80 854.3,80.3 854.4,72.7 851.3,68.5 851.2,67.2 854.4,67.2 854.4,65.8 852.8,64
                      852.8,62.4 887.4,62.4 887.3,56.7 885.3,52.8 885.3,51.7 887.4,51.7 887.4,49.1 894.1,49.1 895.2,8.7 895.6,49.1 900.8,49.1
                      900.8,51.8 902.5,51.6 904.8,57.1 904.5,58.4 902.6,58.4 902.6,62.7 905.5,62.8 909.7,73.4 909.7,76.1 911.1,79.3 911,79.5
                      908.2,79.5 908.3,85.6 914,99.2 913.9,100.6 909.7,100.5 909.7,155 920.5,155.1 920.5,154.5 922.1,154.6 922.1,152.9 923.3,153
                      923.4,149.2 938.3,149.2 938.3,153 939.3,153.1 939.4,154.5 941.1,154.5 941.2,155.1 	"/>
                    <text transform="matrix(1 0 0 1 713.8448 273.8074)">
                      <tspan x="0" y="0" class="kmg_text_title" @click="kmg_building = 'block_a'">Блок A</tspan>
<!--                      <tspan x="0" y="20.4" class="kmg_text_desc">нажмите</tspan>-->
                    </text>
                  </g>
                  <g id="bulding_kmg" opacity="0" class="blockB">
                    <polygon class="kmg_cover" id="bulding_kmg" opacity="0" points="991.1,222.1 990.9,155.1 1071,155.1 1071.2,100.7 1067.1,100.7 1067.1,98.6 1073.3,86.8 1073.3,79.8
                      1070.3,79.8 1070.3,78.4 1072.3,74.7 1071.5,74.7 1071.5,73.6 1077,63 1079,63 1079,58.7 1077,58.7 1076.9,57.4 1081.2,49.5
                      1085.6,49.5 1086.6,9.6 1087.7,49.5 1094.6,49.5 1094.6,52 1096.8,52 1096.8,53.2 1094.7,56.5 1094.7,63 1129.5,63 1129.4,64.3
                      1127.9,66 1127.9,67.6 1130.9,67.6 1130.9,69.2 1127.9,72.6 1127.9,80.5 1150.6,80.5 1150.6,81.2 1149.7,81.9 1149.7,82.6
                      1150.8,82.6 1150.8,83.9 1152.3,83.9 1152.3,86.1 1147.5,90.6 1147.4,102.1 1229.2,102.3 1229.2,98.8 1249,98.8 1249,99.8
                      1249.7,99.9 1249.7,206.9 1118.4,208.6 1118.4,308.8 1214.5,310.1 1214.7,345.8 1113.6,342.7 1112.3,341.5 1095.4,341.6
                      1094.7,340.7 1078.3,340.9 1060.2,341.1 1042.8,341.1 1038.8,335 1039.2,237 1030.5,231.1 1017.8,226.1 1002.7,222.8 	"/>
                    <text transform="matrix(1 0 0 1 1089.89 157.934)">
                      <tspan x="0" y="0" class="kmg_text_title" @click="kmg_building = 'block_b'">Блок B</tspan>
<!--                      <tspan x="0" y="20.4" class="kmg_text_desc">нажмите</tspan>-->
                    </text>
                  </g>
                  <g id="bulding_kmg" opacity="0" class="blockC">
                    <polyline opacity="0" id="bulding_kmg" class="kmg_cover" points="1409.8,235.5 1324.2,236.3 1324.2,205.9 1118.4,208.6 1118.4,308.8 1214.5,310.1 1214.7,345.8 1409.8,356.3 1409.8,235.5 	"/>
                    <text transform="matrix(1 0 0 1 1227.9368 281.1004)">
                      <tspan x="0" y="0" class="kmg_text_title" @click="kmg_building = 'block_c'">Блок C</tspan>
<!--                      <tspan x="0" y="20.4" class="kmg_text_desc">нажмите</tspan>-->
                    </text>
                  </g>
                  <g id="bulding_kmg" opacity="0" class="blockE">
                    <polygon class="kmg_cover" id="bulding_kmg" opacity="0" points="1409.8,356.3 1409.8,235.5 1431,235.5 1431,219.3 1456.1,219.3 1456.1,210.4 1554.9,207.9
                      1554.9,216.8 1598.5,216.6 1598.5,233.7 1948.5,230.1 1948.5,388.5 	"/>
                    <text transform="matrix(1 0 0 1 1624.6533 308.1786)">
                      <tspan x="0" y="0" class="kmg_text_title" @click="kmg_building = 'block_e'">Блок E</tspan>
<!--                      <tspan x="0" y="20.4" class="kmg_text_desc">нажмите</tspan>-->
                    </text>
                  </g>
                </svg>
              </div>
<!--              <div v-if="selectedbuilding.id_building === 3" id="building_3">-->
<!--                <svg version="1.1" id="building" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="100 -90 2230 850" style="enable-background:new 0 0 2263.1 721.7;" xml:space="preserve">-->
<!--                  <defs>-->
<!--                    <script  type="application/ecmascript">-->
<!--                      <![CDATA[-->
<!--                      function svgload_svg(evt){var w=window,w0=null;while(w&&!w.svgload_html&&w!=w0){w0=w;w=w.parent;}if(w)w.svgload_html(evt);}-->
<!--                      ]]>-->
<!--                    </script>-->
<!--                  </defs>-->
<!--                  <rect id="этажи" x="1483.4" class="st0" width="176" height="100"/>-->
<!--                  <g id="этажи_текст">-->
<!--                    <path class="st1" d="M1522.4,37.9c2.2,2.7,3.3,6.7,3.3,12c0,5.2-1.1,9.2-3.3,12c-2.2,2.8-5.3,4.2-9.2,4.2c-2,0-3.7-0.3-5.1-0.9c-1.5-0.6-2.8-1.5-3.9-2.6l2.8-3.4c1,0.8,1.9,1.4,2.8,1.7c0.9,0.4,1.9,0.6,3.2,0.6c4.3,0,6.5-3.2,6.7-9.7h-11.1v-4.4h11.1c-0.3-6-2.5-9-6.5-9c-1.2,0-2.3,0.2-3.2,0.5c-0.9,0.3-1.9,0.9-2.9,1.8l-2.9-3.4c1.3-1.1,2.7-1.9,4.2-2.5c1.5-0.6,3.2-0.9,5.1-0.9C1517.2,33.9,1520.2,35.2,1522.4,37.9z"/>-->
<!--                    <path class="st1" d="M1541.5,39.3v26.2h-5.9V39.3h-8.3v-4.7h22.9l-0.6,4.7H1541.5z"/>-->
<!--                    <path class="st1" d="M1555.5,58.3l-1.9,7.1h-6.1l9.6-30.8h7.3l9.6,30.8h-6.3l-1.9-7.1H1555.5z M1560.6,39.1l-3.9,14.7h7.9L1560.6,39.1z"/>-->
<!--                    <path class="st1" d="M1612.5,65.4h-6.5l-7-13.9h-3.2v13.9h-5.5V51.5h-3.2l-7.1,13.9h-6.4l8.8-16.6l-7.9-14.2h6l6.7,12.5h3.1V34.6h5.5v12.5h3.1l6.8-12.5h5.9l-7.9,14.2L1612.5,65.4z"/>-->
<!--                    <path class="st1" d="M1632.9,65.4V52.3c0-3.8,0.3-7.7,0.8-11.7l-10.5,24.8h-7.3V34.6h5.9v13.3c0,2.5-0.1,4.5-0.2,6.2c-0.1,1.6-0.4,3.4-0.6,5.4l10.7-24.8h7.1v30.9L1632.9,65.4L1632.9,65.4z"/>-->
<!--                  </g>-->
<!--                  <rect id="площадь_помещений" x="1688.7" class="st0" width="574.4" height="100"/>-->
<!--                  <g id="площадь_помещений_текст">-->
<!--                    <path class="st1" d="M1746.6,66.9V40.7h-10.9v26.2h-5.9V36h22.6v30.9L1746.6,66.9L1746.6,66.9z"/>-->
<!--                    <path class="st1" d="M1781.9,66.9h-5.9V40.7h-7.9l-1.4,11.7c-0.4,3.6-0.9,6.4-1.5,8.4c-0.6,2-1.5,3.4-2.6,4.4c-1.1,1-2.7,1.8-4.8,2.3l-1.4-4.3c1.1-0.4,1.9-1,2.5-1.7c0.6-0.7,0.9-1.7,1.2-3c0.3-1.3,0.6-3.4,0.9-6.2L1763,36h18.8L1781.9,66.9L1781.9,66.9L1781.9,66.9L1781.9,66.9z"/>-->
<!--                    <path class="st1" d="M1808.1,37.2c2,1.2,3.6,3.1,4.7,5.5c1.1,2.4,1.6,5.3,1.6,8.7c0,3.4-0.6,6.3-1.7,8.6c-1.1,2.4-2.7,4.3-4.7,5.5c-2,1.3-4.4,1.9-7.1,1.9c-2.8,0-5.2-0.6-7.2-1.9c-2-1.2-3.6-3.1-4.7-5.5c-1.1-2.4-1.7-5.3-1.7-8.7c0-3.3,0.6-6.2,1.7-8.6c1.1-2.4,2.7-4.3,4.7-5.6c2-1.3,4.4-1.9,7.2-1.9C1803.7,35.4,1806.1,36,1808.1,37.2z M1795.5,42.7c-1.2,1.9-1.9,4.8-1.9,8.8c0,7.7,2.5,11.6,7.3,11.6c2.4,0,4.2-0.9,5.4-2.8c1.2-1.8,1.8-4.8,1.8-8.8c0-4-0.6-6.9-1.8-8.8c-1.2-1.8-3-2.8-5.4-2.8C1798.5,39.9,1796.7,40.8,1795.5,42.7z"/>-->
<!--                    <path class="st1" d="M1857.2,73.9h-4.3l-0.8-7.1h-32.2V36h5.8v26.2h8.3V36h5.5v26.2h8.3V36h5.8v26.2h3.6L1857.2,73.9L1857.2,73.9z"/>-->
<!--                    <path class="st1" d="M1865.6,59.7l-1.9,7.1h-6.1l9.6-30.9h7.3l9.6,30.9h-6.3l-1.9-7.1H1865.6z M1870.7,40.6l-3.9,14.7h7.9L1870.7,40.6z"/>-->
<!--                    <path class="st1" d="M1911.7,73.9h-4.3l-0.8-7.1h-17l-0.8,7.1h-4.3V62.3h2.2c0.7-0.7,1.3-1.7,1.7-2.8c0.4-1.2,0.8-2.7,1.2-4.8c0.3-2,0.8-5.1,1.3-9.3l1.2-9.3h16.9v26.2h2.6L1911.7,73.9L1911.7,73.9L1911.7,73.9L1911.7,73.9z M1897.2,40.6l-0.5,4.6c-0.4,3.9-0.8,6.9-1.2,9c-0.4,2.1-0.9,3.8-1.5,5c-0.6,1.2-1.4,2.3-2.3,3.1h11.6V40.6L1897.2,40.6L1897.2,40.6z"/>-->
<!--                    <path class="st1" d="M1935,49.4c2.1,1.6,3.1,4,3.1,7.3c0,3.5-1.1,6-3.3,7.7c-2.2,1.7-5.1,2.5-8.8,2.5h-9.6V36h5.9v10.9h3.7C1929.9,46.9,1932.9,47.8,1935,49.4z M1930.4,61.2c1-0.9,1.6-2.3,1.6-4.4c0-1.9-0.5-3.3-1.5-4.2c-1-0.9-2.6-1.3-4.6-1.3h-3.3v11.2h3.5C1927.9,62.5,1929.3,62,1930.4,61.2z"/>-->
<!--                    <path class="st1" d="M1970.6,66.9V40.7h-10.9v26.2h-5.9V36h22.6v30.9L1970.6,66.9L1970.6,66.9z"/>-->
<!--                    <path class="st1" d="M2002.7,37.2c2,1.2,3.6,3.1,4.7,5.5c1.1,2.4,1.6,5.3,1.6,8.7c0,3.4-0.6,6.3-1.7,8.6c-1.1,2.4-2.7,4.3-4.7,5.5c-2,1.3-4.4,1.9-7.1,1.9c-2.8,0-5.2-0.6-7.2-1.9c-2-1.2-3.6-3.1-4.7-5.5c-1.1-2.4-1.7-5.3-1.7-8.7c0-3.3,0.6-6.2,1.7-8.6c1.1-2.4,2.7-4.3,4.7-5.6c2-1.3,4.4-1.9,7.2-1.9C1998.3,35.4,2000.7,36,2002.7,37.2z M1990.1,42.7c-1.2,1.9-1.9,4.8-1.9,8.8c0,7.7,2.5,11.6,7.3,11.6c2.4,0,4.2-0.9,5.4-2.8c1.2-1.8,1.8-4.8,1.8-8.8c0-4-0.6-6.9-1.8-8.8c-1.2-1.8-3-2.8-5.4-2.8C1993.1,39.9,1991.3,40.8,1990.1,42.7z"/>-->
<!--                    <path class="st1" d="M2037.6,66.9l-0.8-12.9c-0.3-4.6-0.4-8.3-0.4-11v-1.6l-5.6,22.1h-5.6l-6-22.2c0.1,2,0.1,3.4,0.1,4.5c0,2.7-0.1,5.5-0.3,8.3l-0.7,12.7h-5.7L2015,36h7.6l5.5,21.6l5.2-21.6h7.7l2.4,30.9H2037.6L2037.6,66.9z"/>-->
<!--                    <path class="st1" d="M2055.4,40.4V49h9.9v4.4h-9.9v9.1h12.2v4.4h-18.1V36h17.9l-0.6,4.4L2055.4,40.4L2055.4,40.4z"/>-->
<!--                    <path class="st1" d="M2110.5,73.9h-4.3l-0.8-7.1h-32.2V36h5.8v26.2h8.3V36h5.5v26.2h8.3V36h5.8v26.2h3.6L2110.5,73.9L2110.5,73.9L2110.5,73.9z"/>-->
<!--                    <path class="st1" d="M2120.6,40.4V49h9.9v4.4h-9.9v9.1h12.2v4.4h-18.1V36h17.9l-0.6,4.4L2120.6,40.4L2120.6,40.4z"/>-->
<!--                    <path class="st1" d="M2144.2,53.1v13.8h-5.9V36h5.9v12.4h11V36h5.9v30.9h-5.9V53.1L2144.2,53.1L2144.2,53.1z"/>-->
<!--                    <path class="st1" d="M2185.2,66.9V53.8c0-3.8,0.3-7.7,0.9-11.7l-10.5,24.8h-7.3V36h5.8v13.3c0,2.5-0.1,4.5-0.2,6.2c-0.1,1.6-0.4,3.4-0.6,5.3L2184,36h7.1v30.9L2185.2,66.9L2185.2,66.9z"/>-->
<!--                    <path class="st1" d="M2215.2,66.9V53.8c0-3.8,0.3-7.7,0.9-11.7l-10.5,24.8h-7.3V36h5.8v13.3c0,2.5-0.1,4.5-0.2,6.2c-0.1,1.6-0.4,3.4-0.6,5.3L2214,36h7.1v30.9L2215.2,66.9L2215.2,66.9z M2204.6,31.2c-1.3-1.1-2-2.6-2.2-4.5l3.3-0.7c0.3,1,0.8,1.6,1.4,2.1c0.6,0.4,1.5,0.6,2.5,0.6c1,0,1.9-0.2,2.5-0.6c0.7-0.4,1.1-1.1,1.4-2l3.4,0.7c-0.2,1.9-0.9,3.4-2.2,4.5c-1.3,1.1-3,1.7-5.1,1.7C2207.6,32.8,2205.9,32.3,2204.6,31.2z"/>-->
<!--                  </g>-->
<!--                  <g id="etage">-->
<!--                    <g><path class="st2" d="M1488.9,346.9"/></g>-->
<!--                    <g><path class="st2" d="M1488.9,408.6"/></g>-->
<!--                    <g><path class="st2" d="M1488.9,470.1"/></g>-->
<!--                    <g><path class="st2" d="M1488.9,285.3"/></g>-->
<!--                    <g><path class="st2" d="M1488.9,348.8"/></g>-->
<!--                    <g><path class="st2" d="M1488.9,410.5"/></g>-->
<!--                    <g><path class="st2" d="M1488.9,472.1"/></g>-->
<!--                    <g><path class="st2" d="M1488.9,505.9"/></g>-->
<!--                    <g><path class="st2" d="M1488.9,563.6"/></g>-->
<!--                    <g><path class="st2" d="M1528.4,417.2"/></g>-->
<!--                    <g><rect x="1487.9" y="587.7" width="172" height="2"/></g>-->
<!--                    <g><rect x="1487.9" y="649.7" width="172" height="2"/></g>-->
<!--                    <g><rect x="1488.9" y="529.9" width="171" height="2"/></g>-->
<!--                    <g><rect x="1488.9" y="467.8" width="171" height="2"/></g>-->
<!--                    <g><rect x="1488.9" y="407.3" width="171" height="2"/></g>-->
<!--                    <g><rect x="1488.9" y="344.9" width="171" height="2"/></g>-->
<!--                    <g><rect x="1488.9" y="284.4" width="171" height="2"/></g>-->
<!--                    <g><rect x="1689" y="587.7" width="574.1" height="2"/></g>-->
<!--                    <g><rect x="1689" y="529.9" width="574.1" height="2"/></g>-->
<!--                    <g><rect x="1689" y="467.8" width="574.1" height="2"/></g>-->
<!--                    <g><rect x="1689" y="407.3" width="574.1" height="2"/></g>-->
<!--                    <g><rect x="1689" y="344.9" width="574.1" height="2"/></g>-->
<!--                    <g><rect x="1689" y="284.4" width="574.1" height="2"/></g>-->
<!--                    <g><rect x="1688.7" y="649.7" width="574.1" height="2"/></g>-->
<!--                    <g><rect x="1488.9" y="223.9" width="171" height="2"/></g>-->
<!--                    <g><rect x="1488.9" y="163.4" width="171" height="2"/></g>-->
<!--                    <g><rect x="1689" y="223.9" width="574.1" height="2"/></g>-->
<!--                    <g><rect x="1689" y="163.4" width="574.1" height="2"/></g>-->
<!--                    <text id="A1_текст" transform="matrix(1 0 0 1 1562.8149 700.3483)" :class="floors.find(el => el.floor === 1) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 1) ? '1' : '—' }}</text>-->
<!--                    <text id="A2_текст" transform="matrix(1 0 0 1 1564.8208 628.8411)" :class="floors.find(el => el.floor === 1) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 2) ? '2' : '—' }}</text>-->
<!--                    <text id="A3_текст" transform="matrix(1 0 0 1 1562.8149 568.6946)" :class="floors.find(el => el.floor === 1) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 3) ? '3' : '—' }}</text>-->
<!--                    <text id="A4_текст" transform="matrix(1 0 0 1 1562.8149 508.7004)" :class="floors.find(el => el.floor === 1) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 4) ? '4' : '—' }}</text>-->
<!--                    <text id="A5_текст" transform="matrix(1 0 0 1 1562.8149 447.3665)" :class="floors.find(el => el.floor === 1) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 5) ? '5' : '—' }}</text>-->
<!--                    <text id="A6_текст" transform="matrix(1 0 0 1 1562.8149 386.0344)" :class="floors.find(el => el.floor === 1) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 6) ? '6' : '—' }}</text>-->
<!--                    <text id="A7_текст" transform="matrix(1 0 0 1 1562.8149 327.3704)" :class="floors.find(el => el.floor === 1) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 7) ? '7' : '—' }}</text>-->
<!--                    <text id="A8_текст" transform="matrix(1 0 0 1 1564.8206 264.8361)" :class="floors.find(el => el.floor === 1) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 8) ? '8' : '—' }}</text>-->
<!--                    <text id="A9_текст" transform="matrix(1 0 0 1 1564.8209 205.1984)" :class="floors.find(el => el.floor === 1) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 9) ? '9' : '—' }}</text>-->
<!--                    <text id="A10_текст" transform="matrix(1 0 0 1 1551.7527 144.0344)" :class="floors.find(el => el.floor === 1) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 10) ? '10' : '—' }}</text>-->

<!--                    <text id="A1_этаж" transform="matrix(1 0 0 1 1854.7909 694.3455)" :class="floors.find(el => el.floor === 1) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 1) ? 'свободно ' + floors.find(el => el.floor === 1).free_space + ' м' : '—' }}</text>-->
<!--                    <text id="A2_этаж" transform="matrix(1 0 0 1 1854.2284 632.6752)" :class="floors.find(el => el.floor === 2) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 2) ? 'свободно ' + floors.find(el => el.floor === 2).free_space + ' м' : '—' }}</text>-->
<!--                    <text id="A3_этаж" transform="matrix(1 0 0 1 1852.825 572.5266)" :class="floors.find(el => el.floor === 3) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 3) ? 'свободно ' + floors.find(el => el.floor === 3).free_space + ' м' : '—' }}</text>-->
<!--                    <text id="A4_этаж" transform="matrix(1 0 0 1 1852.825 512.5344)" :class="floors.find(el => el.floor === 4) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 4) ? 'свободно ' + floors.find(el => el.floor === 4).free_space + ' м' : '—' }}</text>-->
<!--                    <text id="A5_этаж" transform="matrix(1 0 0 1 1852.825 451.2024)" :class="floors.find(el => el.floor === 5) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 5) ? 'свободно ' + floors.find(el => el.floor === 5).free_space + ' м' : '—' }}</text>-->
<!--                    <text id="A6_этаж" transform="matrix(1 0 0 1 1852.825 389.8704)" :class="floors.find(el => el.floor === 6) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 6) ? 'свободно ' + floors.find(el => el.floor === 6).free_space + ' м' : '—' }}</text>-->
<!--                    <text id="A7_этаж" transform="matrix(1 0 0 1 1852.825 327.3704)" :class="floors.find(el => el.floor === 7) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 7) ? 'свободно ' + floors.find(el => el.floor === 7).free_space + ' м' : '—' }}</text>-->
<!--                    <text id="A8_этаж" transform="matrix(1 0 0 1 1854.7914 268.6699)" :class="floors.find(el => el.floor === 8) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 8) ? 'свободно ' + floors.find(el => el.floor === 8).free_space + ' м' : '—' }}</text>-->
<!--                    <text id="A9_этаж" transform="matrix(1 0 0 1 1854.7909 209.0325)" :class="floors.find(el => el.floor === 9) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 9) ? 'свободно ' + floors.find(el => el.floor === 9).free_space + ' м' : '—' }}</text>-->
<!--                    <text id="A10_этаж" transform="matrix(1 0 0 1 1854.7915 144.0342)" :class="floors.find(el => el.floor === 10) ? 'st5 st4' : 'disabled st5 st4'">{{ floors.find(el => el.floor === 10) ? 'свободно ' + floors.find(el => el.floor === 10).free_space + ' м' : '—' }}</text>-->
<!--                  </g>-->
<!--                  <g id="group">-->
<!--                    <rect v-if="floors.find(el => el.floor === 10)" id="floor_10" opacity="0"  x="0.6" y="104.9" class="st5" width="2262.5" height="58.5"/>-->
<!--                    <rect v-if="floors.find(el => el.floor === 9)" id="floor_9" opacity="0"  x="0.6" y="165.4" class="st5" width="2262.5" height="58.5"/>-->
<!--                    <rect v-if="floors.find(el => el.floor === 8)" id="floor_8" opacity="0"  x="0.6" y="225.9" class="st5" width="2262.5" height="58"/>-->
<!--                    <rect v-if="floors.find(el => el.floor === 7)" id="floor_7" opacity="0"  x="0.6" y="286.4" class="st5" width="2262.5" height="58.5"/>-->
<!--                    <rect v-if="floors.find(el => el.floor === 6)" id="floor_6" opacity="0"  x="0.6" y="346.8" class="st5" width="2262.5" height="60.5"/>-->
<!--                    <rect v-if="floors.find(el => el.floor === 5)" id="floor_5" opacity="0"  x="0.6" y="409.3" class="st5" width="2262.5" height="58.5"/>-->
<!--                    <rect v-if="floors.find(el => el.floor === 4)" id="floor_4" opacity="0"  x="0.1" y="469.8" class="st5" width="2262.5" height="60.1"/>-->
<!--                    <rect v-if="floors.find(el => el.floor === 3)" id="floor_3" opacity="0"  x="0" y="531.8" class="st5" width="2262.5" height="55.9"/>-->
<!--                    <rect v-if="floors.find(el => el.floor === 2)" id="floor_2" opacity="0"  x="0" y="589.7" class="st5" width="2262.5" height="60.1"/>-->
<!--                    <rect v-if="floors.find(el => el.floor === 1)" id="floor_1" opacity="0"  x="0" y="651.7" class="st5" width="2262.5" height="60.1"/>-->
<!--                  </g>-->
<!--                </svg>-->
<!--              </div>-->
              <div v-if="selectedbuilding.id_building === 1 || selectedbuilding.id_building === 2" id="building_1">
                <svg version="1.1" x="0px" y="0px" viewBox="100 -90 2230 850" style="enable-background:new 0 0 2263.1 721.7;" xml:space="preserve">
                  <defs>
                    <script  type="application/ecmascript">
                      <![CDATA[
                      function svgload_svg(evt){var w=window,w0=null;while(w&&!w.svgload_html&&w!=w0){w0=w;w=w.parent;}if(w)w.svgload_html(evt);}
                      ]]>
                    </script>
                  </defs>
                  <rect x="883.2" class="st0" width="176" height="100"/>
                  <g>
                    <path class="st1" d="M922.1,37.9c2.2,2.7,3.3,6.7,3.3,12c0,5.2-1.1,9.2-3.3,12c-2.2,2.8-5.3,4.2-9.2,4.2c-2,0-3.7-0.3-5.1-0.9c-1.5-0.6-2.8-1.5-3.9-2.6l2.8-3.4c1,0.8,1.9,1.4,2.8,1.7c0.9,0.4,1.9,0.6,3.2,0.6c4.3,0,6.5-3.2,6.7-9.7h-11.1v-4.4h11.1c-0.3-6-2.5-9-6.5-9c-1.2,0-2.3,0.2-3.2,0.5c-0.9,0.3-1.9,0.9-2.9,1.8l-2.9-3.4c1.3-1.1,2.7-1.9,4.2-2.5c1.5-0.6,3.2-0.9,5.1-0.9C916.9,33.9,919.9,35.2,922.1,37.9z"/>
                    <path class="st1" d="M941.2,39.3v26.2h-5.9V39.3H927v-4.7h22.9l-0.6,4.7H941.2z"/>
                    <path class="st1" d="M955.2,58.3l-1.9,7.1h-6.1l9.6-30.8h7.3l9.6,30.8h-6.3l-1.9-7.1H955.2z M960.3,39.1l-3.9,14.7h7.9L960.3,39.1z"/>
                    <path class="st1" d="M1012.2,65.4h-6.5l-7-13.9h-3.2v13.9H990V51.5h-3.2l-7.1,13.9h-6.4l8.8-16.6l-7.9-14.2h6l6.7,12.5h3.1V34.6h5.5v12.5h3.1l6.8-12.5h5.9l-7.9,14.2L1012.2,65.4z"/>
                    <path class="st1" d="M1032.7,65.4V52.3c0-3.8,0.3-7.7,0.8-11.7L1023,65.4h-7.3V34.6h5.9v13.3c0,2.5-0.1,4.5-0.2,6.2c-0.1,1.6-0.4,3.4-0.6,5.4l10.7-24.8h7.1v30.9L1032.7,65.4L1032.7,65.4z"/></g>
                  <path class="st2" d="M414.2,771.7"/>
                  <rect x="1100" class="st0" width="1170" height="100"/>
                  <g>
                    <path class="st1" d="M1450.3,66.9V40.7h-10.9v26.2h-5.9V36h22.6v30.9L1450.3,66.9L1450.3,66.9z"/>
                    <path class="st1" d="M1485.5,66.9h-5.9V40.7h-7.9l-1.4,11.7c-0.4,3.6-0.9,6.4-1.5,8.4c-0.6,2-1.5,3.4-2.6,4.4c-1.1,1-2.7,1.8-4.8,2.3l-1.4-4.3c1.1-0.4,1.9-1,2.5-1.7c0.6-0.7,0.9-1.7,1.2-3c0.3-1.3,0.6-3.4,0.9-6.2l1.9-16.3h18.8L1485.5,66.9L1485.5,66.9L1485.5,66.9L1485.5,66.9z"/>
                    <path class="st1" d="M1511.7,37.2c2,1.2,3.6,3.1,4.7,5.5c1.1,2.4,1.6,5.3,1.6,8.7c0,3.4-0.6,6.3-1.7,8.6c-1.1,2.4-2.7,4.3-4.7,5.5c-2,1.3-4.4,1.9-7.1,1.9c-2.8,0-5.2-0.6-7.2-1.9c-2-1.2-3.6-3.1-4.7-5.5c-1.1-2.4-1.7-5.3-1.7-8.7c0-3.3,0.6-6.2,1.7-8.6c1.1-2.4,2.7-4.3,4.7-5.6c2-1.3,4.4-1.9,7.2-1.9C1507.3,35.4,1509.7,36,1511.7,37.2z M1499.1,42.7c-1.2,1.9-1.9,4.8-1.9,8.8c0,7.7,2.5,11.6,7.3,11.6c2.4,0,4.2-0.9,5.4-2.8c1.2-1.8,1.8-4.8,1.8-8.8c0-4-0.6-6.9-1.8-8.8c-1.2-1.8-3-2.8-5.4-2.8C1502.2,39.9,1500.4,40.8,1499.1,42.7z"/>
                    <path class="st1" d="M1560.8,73.9h-4.3l-0.8-7.1h-32.2V36h5.8v26.2h8.3V36h5.5v26.2h8.3V36h5.8v26.2h3.6L1560.8,73.9L1560.8,73.9z"/>
                    <path class="st1" d="M1569.2,59.7l-1.9,7.1h-6.1l9.6-30.9h7.3l9.6,30.9h-6.3l-1.9-7.1H1569.2z M1574.3,40.6l-3.9,14.7h7.9L1574.3,40.6z"/>
                    <path class="st1" d="M1615.3,73.9h-4.3l-0.8-7.1h-17l-0.8,7.1h-4.3V62.3h2.2c0.7-0.7,1.3-1.7,1.7-2.8c0.4-1.2,0.8-2.7,1.2-4.8c0.3-2,0.8-5.1,1.3-9.3l1.2-9.3h16.9v26.2h2.6L1615.3,73.9L1615.3,73.9L1615.3,73.9L1615.3,73.9z M1600.8,40.6l-0.5,4.6c-0.4,3.9-0.8,6.9-1.2,9c-0.4,2.1-0.9,3.8-1.5,5c-0.6,1.2-1.4,2.3-2.3,3.1h11.6V40.6L1600.8,40.6L1600.8,40.6z"/>
                    <path class="st1" d="M1638.6,49.4c2.1,1.6,3.1,4,3.1,7.3c0,3.5-1.1,6-3.3,7.7c-2.2,1.7-5.1,2.5-8.8,2.5h-9.6V36h5.9v10.9h3.7C1633.6,46.9,1636.5,47.8,1638.6,49.4z M1634,61.2c1-0.9,1.6-2.3,1.6-4.4c0-1.9-0.5-3.3-1.5-4.2c-1-0.9-2.6-1.3-4.6-1.3h-3.3v11.2h3.5C1631.5,62.5,1633,62,1634,61.2z"/>
                    <path class="st1" d="M1674.2,66.9V40.7h-10.9v26.2h-5.9V36h22.6v30.9L1674.2,66.9L1674.2,66.9z"/>
                    <path class="st1" d="M1706.3,37.2c2,1.2,3.6,3.1,4.7,5.5c1.1,2.4,1.6,5.3,1.6,8.7c0,3.4-0.6,6.3-1.7,8.6c-1.1,2.4-2.7,4.3-4.7,5.5c-2,1.3-4.4,1.9-7.1,1.9c-2.8,0-5.2-0.6-7.2-1.9c-2-1.2-3.6-3.1-4.7-5.5c-1.1-2.4-1.7-5.3-1.7-8.7c0-3.3,0.6-6.2,1.7-8.6c1.1-2.4,2.7-4.3,4.7-5.6c2-1.3,4.4-1.9,7.2-1.9C1701.9,35.4,1704.3,36,1706.3,37.2z M1693.7,42.7c-1.2,1.9-1.9,4.8-1.9,8.8c0,7.7,2.5,11.6,7.3,11.6c2.4,0,4.2-0.9,5.4-2.8c1.2-1.8,1.8-4.8,1.8-8.8c0-4-0.6-6.9-1.8-8.8c-1.2-1.8-3-2.8-5.4-2.8C1696.8,39.9,1694.9,40.8,1693.7,42.7z"/>
                    <path class="st1" d="M1741.2,66.9l-0.8-12.9c-0.3-4.6-0.4-8.3-0.4-11v-1.6l-5.6,22.1h-5.6l-6-22.2c0.1,2,0.1,3.4,0.1,4.5c0,2.7-0.1,5.5-0.3,8.3l-0.7,12.7h-5.7l2.5-30.9h7.6l5.5,21.6l5.2-21.6h7.7l2.4,30.9H1741.2L1741.2,66.9z"/>
                    <path class="st1" d="M1759.1,40.4V49h9.9v4.4h-9.9v9.1h12.2v4.4h-18.1V36h17.9l-0.6,4.4L1759.1,40.4L1759.1,40.4z"/>
                    <path class="st1" d="M1814.1,73.9h-4.3l-0.8-7.1h-32.2V36h5.8v26.2h8.3V36h5.5v26.2h8.3V36h5.8v26.2h3.6L1814.1,73.9L1814.1,73.9L1814.1,73.9z"/>
                    <path class="st1" d="M1824.2,40.4V49h9.9v4.4h-9.9v9.1h12.2v4.4h-18.1V36h17.9l-0.6,4.4L1824.2,40.4L1824.2,40.4z"/>
                    <path class="st1" d="M1847.8,53.1v13.8h-5.9V36h5.9v12.4h11V36h5.9v30.9h-5.9V53.1L1847.8,53.1L1847.8,53.1z"/>
                    <path class="st1" d="M1888.9,66.9V53.8c0-3.8,0.3-7.7,0.9-11.7l-10.5,24.8h-7.3V36h5.8v13.3c0,2.5-0.1,4.5-0.2,6.2c-0.1,1.6-0.4,3.4-0.6,5.3l10.7-24.8h7.1v30.9L1888.9,66.9L1888.9,66.9z"/>
                    <path class="st1" d="M1918.9,66.9V53.8c0-3.8,0.3-7.7,0.9-11.7l-10.5,24.8h-7.3V36h5.8v13.3c0,2.5-0.1,4.5-0.2,6.2c-0.1,1.6-0.4,3.4-0.6,5.3l10.7-24.8h7.1v30.9L1918.9,66.9L1918.9,66.9z M1908.2,31.2c-1.3-1.1-2-2.6-2.2-4.5l3.3-0.7c0.3,1,0.8,1.6,1.4,2.1c0.6,0.4,1.5,0.6,2.5,0.6c1,0,1.9-0.2,2.5-0.6c0.7-0.4,1.1-1.1,1.4-2l3.4,0.7c-0.2,1.9-0.9,3.4-2.2,4.5c-1.3,1.1-3,1.7-5.1,1.7C1911.2,32.8,1909.5,32.3,1908.2,31.2z"/>
                  </g>
                  <g>
                    <text transform="matrix(1 0 0 1 957.364 700.348)" class="st4 st5">{{ floors.find(el => el.floor === 1) ? '1' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 964.0764 628.8411)" class="st4 st5">{{ floors.find(el => el.floor === 2) ? '2' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 962.0706 568.6946)" class="st4 st5">{{ floors.find(el => el.floor === 3) ? '3' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 962.0706 508.7004)" class="st4 st5">{{ floors.find(el => el.floor === 4) ? '4' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 962.0706 447.3665)" class="st4 st5">{{ floors.find(el => el.floor === 5) ? '5' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 962.0706 386.0344)" class="st4 st5">{{ floors.find(el => el.floor === 6) ? '6' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 962.0706 327.3704)" class="st4 st5">{{ floors.find(el => el.floor === 7) ? '7' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 964.0763 264.8361)" class="st4 st5">{{ floors.find(el => el.floor === 8) ? '8' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 964.0766 205.1984)" class="st4 st5">{{ floors.find(el => el.floor === 9) ? '9' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 951.0083 144.0344)" class="st4 st5">{{ floors.find(el => el.floor === 10) ? '10' : '—' }}</text>

                    <text transform="matrix(1 0 0 1 1636.2024 694.3455)" class="st4 st5">{{ floors.find(el => el.floor === 1) ? 'свободно ' + floors.find(el => el.floor === 1).free_space + ' м' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 1635.64 632.6752)" class="st4 st5">{{ floors.find(el => el.floor === 2) ? 'свободно ' + floors.find(el => el.floor === 2).free_space + ' м' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 1634.2366 572.5266)" class="st4 st5">{{ floors.find(el => el.floor === 3) ? 'свободно ' + floors.find(el => el.floor === 3).free_space + ' м' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 1634.2366 512.5344)" class="st4 st5">{{ floors.find(el => el.floor === 4) ? 'свободно ' + floors.find(el => el.floor === 4).free_space + ' м' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 1634.2366 451.2024)" class="st4 st5">{{ floors.find(el => el.floor === 5) ? 'свободно ' + floors.find(el => el.floor === 5).free_space + ' м' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 1634.2366 389.8704)" class="st4 st5">{{ floors.find(el => el.floor === 6) ? 'свободно ' + floors.find(el => el.floor === 6).free_space + ' м' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 1634.2366 327.3704)" class="st4 st5">{{ floors.find(el => el.floor === 7) ? 'свободно ' + floors.find(el => el.floor === 7).free_space + ' м' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 1636.2029 268.6699)" class="st4 st5">{{ floors.find(el => el.floor === 8) ? 'свободно ' + floors.find(el => el.floor === 8).free_space + ' м' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 1636.2025 209.0325)" class="st4 st5">{{ floors.find(el => el.floor === 9) ? 'свободно ' + floors.find(el => el.floor === 9).free_space + ' м' : '—' }}</text>
                    <text transform="matrix(1 0 0 1 1636.2031 144.0342)" class="st4 st5">{{ floors.find(el => el.floor === 10) ? 'свободно ' + floors.find(el => el.floor === 10).free_space + ' м' : '—' }}</text>
                    <g><rect x="887.1" y="587.7" width="172" height="2"/></g>
                    <g><rect x="887.1" y="649.7" width="172" height="2"/></g>
                    <g><rect x="888.1" y="529.9" width="171" height="2"/></g>
                    <g><rect x="888.1" y="467.8" width="171" height="2"/></g>
                    <g><rect x="888.1" y="407.3" width="171" height="2"/></g>
                    <g><rect x="888.1" y="344.9" width="171" height="2"/></g>
                    <g><rect x="888.1" y="284.4" width="171" height="2"/></g>
                    <g><path class="st3" d="M1528.4,417.2"/></g>
                    <g><rect x="1095.1" y="587.7" width="1168" height="2"/></g>
                    <g><rect x="1095.1" y="529.9" width="1168" height="2"/></g>
                    <g><rect x="1095.1" y="467.8" width="1168" height="2"/></g>
                    <g><rect x="1095.1" y="407.3" width="1168" height="2"/></g>
                    <g><rect x="1095.1" y="344.9" width="1168" height="2"/></g>
                    <g><rect x="1095.1" y="284.4" width="1168" height="2"/></g>
                    <g><rect x="1094.6" y="649.7" width="1168" height="2"/></g>
                    <g><rect x="1094.7" y="711.7" width="1168" height="2"/></g>
                    <g><rect x="887.1" y="711.7" width="172" height="2"/></g>
                    <g><rect x="888.1" y="223.9" width="171" height="2"/></g>
                    <g><rect x="888.1" y="163.4" width="171" height="2"/></g>
                    <g><rect x="1095.1" y="223.9" width="1168" height="2"/></g>
                    <g><rect x="1095.1" y="163.4" width="1168" height="2"/></g>
                  </g>
                  <rect v-if="floors.find(el => el.floor === 10)" id="floor_10" opacity="0" x="0.6" y="104.9" class="st7" width="2262.5" height="58.5"/>
                  <rect v-if="floors.find(el => el.floor === 9)" id="floor_9" opacity="0" x="0.6" y="165.4" class="st7" width="2262.5" height="58.5"/>
                  <rect v-if="floors.find(el => el.floor === 8)" id="floor_8" opacity="0" x="0.6" y="225.9" class="st7" width="2262.5" height="58"/>
                  <rect v-if="floors.find(el => el.floor === 7)" id="floor_7" opacity="0" x="0.6" y="286.4" class="st7" width="2262.5" height="58.5"/>
                  <rect v-if="floors.find(el => el.floor === 6)" id="floor_6" opacity="0" x="0.6" y="346.8" class="st7" width="2262.5" height="60.5"/>
                  <rect v-if="floors.find(el => el.floor === 5)" id="floor_5" opacity="0" x="0.6" y="409.3" class="st7" width="2262.5" height="58.5"/>
                  <rect v-if="floors.find(el => el.floor === 4)" id="floor_4" opacity="0" x="0.1" y="469.8" class="st7" width="2262.5" height="60.1"/>
                  <rect v-if="floors.find(el => el.floor === 3)" id="floor_3" opacity="0" x="0" y="531.8" class="st7" width="2262.5" height="55.9"/>
                  <rect v-if="floors.find(el => el.floor === 2)" id="floor_2" opacity="0" x="0" y="589.7" class="st7" width="2262.5" height="60.1"/>
                  <rect v-if="floors.find(el => el.floor === 1)" id="floor_1" opacity="0" x="0" y="651.7" class="st7" width="2262.5" height="60.1"/>
                </svg>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-expand-transition>
    </template>
  </base-section>
</template>

<script>
  import axios from 'axios'
  // import TooltipHeatMap from '../../components/tooltip-heat-map'
  export default {
    name: 'SectionBusinessCentres',
    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
    },
    // components: {
    //   TooltipHeatMap,
    // },
    data () {
      return {
        loading: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
        map: [],
        floors: [],
        carousel: 1,
        dialog: {
          contactForm: false,
        },
        kmg_building: null,
        selectedbuilding: {
          id_building: null,
          name_building: null,
          areas: [],
          floors: null,
          description: []
        },
        toolbar: {
          floor: {
            from: null,
            to: null,
            items: [],
          },
          area: {
            from: null,
            to: null,
            items: [0, 10, 20, 30, 50, 80, 130, 190, 320, 510],
          },
        },
        business: [
          {
            id_building: 1,
            name_building: 'Бизнес центр 1',
            image: 'business-centre.jpg',
            areas: [],
            expand: false,
            description: [
              {
                icon: 'mdi-map-marker-outline',
                title: 'Расположение',
                text: 'г.Нур-Султан, пр. Кабанбай б. 17 н.п.15 (блок А)',
              },
              {
                icon: 'mdi-email',
                title: 'Тип',
                text: 'Административное здание',
              },
            ],
          },
          {
            id_building: 2,
            name_building: 'Бизнес центр 2',
            image: 'business-centre-2.jpg',
            areas: [],
            expand: false,
            description: [
              {
                icon: 'mdi-map-marker-outline',
                title: 'Расположение',
                text: 'г.Нур-Султан, пр.Кабанбай б. 17 н.п.14 (блок Е)',
              },
              {
                icon: 'mdi-email',
                title: 'Тип',
                text: 'Административное здание',
              },
            ],
          },
          {
            id_building: 3,
            name_building: 'Бизнес центр 3',
            image: 'business-centre-3.jpg',
            areas: [],
            expand: false,
            description: [
              {
                icon: 'mdi-map-marker-outline',
                title: 'Расположение',
                text: 'г.Нур-Султан, пр.Кабанбай б. 19 (блок A, B, С, Е)',
              },
              {
                icon: 'mdi-email',
                title: 'Тип',
                text: 'Административное здание',
              },
            ],
          },
        ],
        headers: [
          { text: 'Назначение', value: 'type', align: 'start', sortable: false },
          { text: 'Офис', value: 'office' },
          { text: 'Площадь', value: 'square' },
          { text: 'Этажность', value: 'floor' },
        ],
        itemsData: [],
        table_items: [],
      }
    },
    methods: {
      open (value) {
        this.selectedbuilding.id_building = this.business.find(el => el.id_building === value).id_building
        this.selectedbuilding.name_building = this.business.find(el => el.id_building === value).name_building
        this.selectedbuilding.areas = this.business.find(el => el.id_building === value).areas
        this.selectedbuilding.floors = this.business.find(el => el.id_building === value).floors
        this.selectedbuilding.description = this.business.find(el => el.id_building === value).description
        this.getData(this.selectedbuilding.id_building)
        // this.getMap(this.selectedbuilding.id_building, 1)
      },
      getMap (building, floor) {
        this.loading[floor] = true
        var body = {
          id_building: building,
          floor: floor,
        }
        var self = this
        axios.post('https://ibc.kz/app/areas/map', body).then(function (response) {
          if (response.data) {
            self.map = response.data
          }
          self.loading[floor] = false
        })
      },
      getData (value) {
        for (var i = 1; i <= 3; i++) {
          var self = this
          if (i === value) {
            if (!self.business[i - 1].expand) {
              var data = {
                id_building: value,
              }
              axios.post('https://ibc.kz/app/areas/floors', data).then(function (response) {
                self.floors = response.data
              })
              self.business[i - 1].expand = !self.business[i - 1].expand
            } else {
              self.business[i - 1].expand = !self.business[i - 1].expand
            }
          } else {
            self.business[i - 1].expand = false
          }
        }
      },
    },
  }
</script>
<style type="text/css">
#building_1 {
  height: 410px;
  background: url(https://ibc.kz/lukoil.png) left top no-repeat;
  position: relative;
}
#building_2 {
  height: 410px;
  background: url(https://ibc.kz/lukoil.png) left top no-repeat;
  position: relative;
}
#building_3 {
  height: 420px;
  background: url(https://ibc.kz/kmg_c.png) left top no-repeat;
  position: relative;
}
#kmg_class {
  width: 100%;
  height: 180pt;
  background: url(https://ibc.kz/kmg_main.png) center top no-repeat;
  background-size: 100%;
  position: relative;
}
#floor_10:hover {
  fill: #82CCB4;
  opacity: 0.7;
}
#floor_9:hover {
  fill: #82CCB4;
  opacity: 0.7;
}
#floor_8:hover {
  fill: #82CCB4;
  opacity: 0.7;
}
#floor_7:hover {
  fill: #82CCB4;
  opacity: 0.7;
}
#floor_6:hover {
  fill: #82CCB4;
  opacity: 0.7;
}
#floor_5:hover {
  fill: #82CCB4;
  opacity: 0.7;
}
#floor_4:hover {
  fill: #82CCB4;
  opacity: 0.7;
}
#floor_3:hover {
  fill: #82CCB4;
  opacity: 0.7;
}
#floor_2:hover {
  fill: #82CCB4;
  opacity: 0.7;
}
#floor_1:hover {
  fill: #82CCB4;
  opacity: 0.7;
}

#bulding_kmg:hover {
  fill: #82CCB4;
  opacity: 0.8;
}
.disabled {
  fill: #e4e4e4;
}
.st0{fill:#204165 !important;}
.st1{fill:#FFFFFF;}
.st2{fill:none;stroke:#91D1C0;stroke-miterlimit:10;}
.st3{stroke:#FFFFFF;stroke-miterlimit:10;}
.st4{font-family:'Roboto';}
.st5{font-size:32.5857px;}
.st6{font-size:19.1682px;}
.st7{fill:#82CCB4;}
.kmg_cover {
  fill:#043125!important
}
.kmg_text_title {
  fill:#fff;
  stroke-miterlimit:10;
  font-size:40px;
  font-family:'Roboto';
}
.kmg_text_desc {
  fill:#fff;
  stroke-miterlimit:10;
  font-family:'Roboto';
  font-size:17px;
}
</style>
